/**
 * Living Nectar Custom JS
 * Adds View Details link and fixes View Cart in subscription widget
 */
(function() {
  let linkAdded = false;
  let cartFixed = false;
  
  function addViewDetailsLink() {
    if (linkAdded) return;
    
    // Find View Cart button by text content
    const allButtons = document.querySelectorAll('button, a, [role="button"]');
    let viewCartBtn = null;
    
    allButtons.forEach(btn => {
      const text = btn.textContent.trim().toLowerCase();
      if (text.includes('view cart') && !btn.classList.contains('ln-view-details-link')) {
        viewCartBtn = btn;
      }
    });
    
    if (viewCartBtn) {
      // Create View Details link
      const viewDetailsLink = document.createElement('a');
      viewDetailsLink.href = '/products/living-nectar-palmyra-palm-sugar';
      viewDetailsLink.className = 'ln-view-details-link';
      viewDetailsLink.textContent = 'View Details →';
      viewDetailsLink.style.cssText = `
        display: block;
        text-align: center;
        margin-top: 12px;
        color: #1a3329;
        font-size: 14px;
        text-decoration: none;
        font-weight: 500;
        cursor: pointer;
      `;
      viewDetailsLink.addEventListener('mouseenter', function() {
        this.style.textDecoration = 'underline';
      });
      viewDetailsLink.addEventListener('mouseleave', function() {
        this.style.textDecoration = 'none';
      });
      
      // Insert after the View Cart button's parent container
      const container = viewCartBtn.parentElement;
      if (container) {
        container.appendChild(viewDetailsLink);
        linkAdded = true;
        console.log('[LN] View Details link added');
      }
    }
  }
  
  function fixViewCartButton() {
    if (cartFixed) return;
    
    const allButtons = document.querySelectorAll('button, a, [role="button"]');
    
    allButtons.forEach(btn => {
      const text = btn.textContent.trim().toLowerCase();
      if (text.includes('view cart') && !btn.hasAttribute('data-ln-fixed')) {
        btn.setAttribute('data-ln-fixed', 'true');
        btn.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          window.location.href = '/cart';
        });
        cartFixed = true;
        console.log('[LN] View Cart button fixed');
      }
    });
  }
  
  function init() {
    addViewDetailsLink();
    fixViewCartButton();
  }
  
  // Run multiple times to catch dynamically loaded content
  const timers = [500, 1000, 1500, 2000, 3000, 5000];
  timers.forEach(t => setTimeout(init, t));
  
  // Watch for DOM changes
  const observer = new MutationObserver(function(mutations) {
    setTimeout(init, 100);
  });
  
  if (document.body) {
    observer.observe(document.body, { childList: true, subtree: true });
  } else {
    document.addEventListener('DOMContentLoaded', function() {
      observer.observe(document.body, { childList: true, subtree: true });
    });
  }
})();
